// Homepage FAQ content (English). FAQ schema is generated from this on the home page.
export const FAQS = [
  {
    q: "Is Plastic Surgery Vietnam a clinic?",
    a: "No. Plastic Surgery Vietnam is an independent international patient information and coordination platform. It is not a clinic, hospital, doctor or medical provider, and it does not diagnose conditions or provide treatment.",
  },
  {
    q: "How does the case-review process work?",
    a: "You share what you are considering through our private form. Our team reviews the enquiry, explains the appropriate next steps, and can help arrange direct consultations with suitable medical professionals.",
  },
  {
    q: "Can a surgeon assess me from photographs?",
    a: "Photographs can support an initial review only. They do not replace an in-person examination, and a final treatment recommendation always comes from a licensed medical professional.",
  },
  {
    q: "How do I choose a plastic surgeon in Vietnam?",
    a: "Consider the surgeon's licensing and credentials, the operating facility, their experience with your specific procedure, and how clearly they discuss risks and realistic outcomes. Our guides explain what to check.",
  },
  {
    q: "How do I check a surgeon's licence?",
    a: "We provide guidance on the questions to ask and the documentation to request so you can verify a surgeon's licensing and where surgery will take place.",
  },
  {
    q: "Where will surgery take place?",
    a: "Surgery should take place in an appropriately licensed hospital or facility. We help confirm the operating location as part of the review process.",
  },
  {
    q: "Is plastic surgery in Vietnam safe?",
    a: "Safety depends on the individual surgeon, facility, anaesthesia, your health, the procedure and aftercare — not simply the country. No procedure is risk-free.",
  },
  {
    q: "How much does plastic surgery in Vietnam cost?",
    a: "Cost depends on many factors, including the procedure, surgeon, facility, anaesthesia, implants, hospital nights, tests, medication and follow-up. We do not publish fixed prices; an indicative quotation follows an assessment.",
  },
  {
    q: "What is normally included in a quotation?",
    a: "A quotation may include the surgeon's fee, facility and anaesthesia, and some tests, medication or follow-up. Quotations are indicative and may change if clinical findings differ.",
  },
  {
    q: "How long should I stay in Vietnam?",
    a: "This depends on the operation, follow-up appointments, suture removal, swelling, mobility and your surgeon's travel-clearance advice. We can share general guidance for planning.",
  },
  {
    q: "Can you help with revision surgery?",
    a: "Yes, we help organise the information needed for an appropriate professional review of revision cases. We cannot promise that every revision case can be accepted.",
  },
  {
    q: "Can you help with travel and accommodation?",
    a: "We can provide guidance and coordination. Travel, accommodation, transport and translation may be delivered by third parties and are confirmed according to your individual case.",
  },
  {
    q: "What support is available after surgery?",
    a: "We support communication during recovery and can help coordinate follow-up. Optional nurse or recovery support may be arranged depending on the case.",
  },
  {
    q: "What happens after I return home?",
    a: "We help maintain communication with your care team and support follow-up arrangements after you return home.",
  },
  {
    q: "Do you provide support in French or German?",
    a: "Yes. We offer communication in English, French and German to support international patients.",
  },
];
